/**
 * Where clicking a node goes.
 *
 * Notes route through openItem, which already switches to the Notes app, opens
 * the tab, touches recents and reveals in the tree.
 */
import { openByTitle, openItem } from "@/commands/nav";
import { usePalette } from "@/store/palette";
import type { GraphNode } from "./types";

export function openGraphNode(node: GraphNode, newTab: boolean): void {
  switch (node.kind) {
    case "note":
      if (node.itemId) openItem(node.itemId, newTab ? { newTab: true } : undefined);
      return;
    case "tag":
      usePalette.getState().open("switcher", `#${node.titleLower}`);
      return;
    case "attachment":
      // an imported vault-relative filename has no URL here, so there is
      // nothing to open
      if (node.href) window.open(node.href, "_blank", "noopener,noreferrer");
      return;
    case "unresolved":
      // create: false is load-bearing. openByTitle creates a note on miss, so
      // without it a stray click in a dense graph silently spawns notes.
      openByTitle(node.label, undefined, { create: false });
      return;
  }
}
